module.exports = __webpack_public_path__ + "img/GSC.c81dfe95.svg";